export default __webpack_public_path__ + "static/media/general-savings.93c6cb3b.png";